export default {
  MuiAppBar: {
    styleOverrides: {
      root: {
        background: '#ffffff',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
        borderRadius: '0px'
      }
    }
  }
};
